import ZkRoleGroup from './src/main'
ZkRoleGroup.install = function (Vue) {
  Vue.component(ZkRoleGroup.name, ZkRoleGroup)
}
export default ZkRoleGroup



// WEBPACK FOOTER //
// ./src/cdpBase/baseComponents/roleGroup/index.js